import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const IconContainer = styled.div``;

export const Heading = styled.div`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodyLargeSemibold
      : textStyleCss(theme.atlas.typography.semantic.body)}
  font-weight: 600;
  margin-top: 20px;
  text-align: center;
`;

export const Description = styled.div`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodySmall
      : textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  margin-top: 20px;
  text-align: center;
`;
